import * as THREE from 'three'

const LookUpShader = {

  uniforms: {
    "tDiffuse": { value: null },
    "color1": { type: "c", value: new THREE.Color(0xff0000) },
    "color2": { type: "c", value: new THREE.Color(0x00ff00) },
    "color3": { type: "c", value: new THREE.Color(0x0000ff) },
    "color4": { type: "c", value: new THREE.Color(0xffff00) },
  },

  vertexShader: [

    "varying vec2 vUv;",

    "void main() {",

    "	vUv = uv;",
    "	gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );",

    "}"

  ].join("\n"),

  fragmentShader: [

    "uniform sampler2D tDiffuse;",

    "uniform vec3 color1;",
    "uniform vec3 color2;",
    "uniform vec3 color3;",
    "uniform vec3 color4;",

    "varying vec2 vUv;",

    "void main() {",

    "vec4 texture = texture2D(tDiffuse, vUv);",

    " float step1 = 0.0;",
    " float step2 = 0.33;",
    " float step3 = 0.66;",
    " float step4 = 1.0;",

    " float sample = clamp(texture.r * 1.25, 0.0, 1.0);",
    " vec3 color = mix(color1, color2, smoothstep(step1, step2, sample));",
    " color = mix(color, color3, smoothstep(step2, step3, sample));",
    " color = mix(color, color4, smoothstep(step3, step4, sample));",

    "	gl_FragColor.rgb = color;",
    "	gl_FragColor.a = 1.0;",

    "}"

  ].join("\n")

};

export { LookUpShader }